'use client';

import { X } from 'lucide-react';
import Image from 'next/image';
import { Player, Stage } from '@repo/types';
import { useTeamContext } from '../../providers/TeamContext';
import { getDriverBackgroundColor, toMillionPrice, formatPrice } from '../../lib/utils';
import { useCompetitionContext } from "../../providers/CompetitionContext";

interface DriverSelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  drivers: Player[];
  selectionType: 'fantasyPick' | 'predictionPick';
  selectionStage: Stage | undefined;
  selectedIndex: number;
}

export function DriverSelectModal({ isOpen, onClose, drivers, selectionType, selectionStage, selectedIndex }: DriverSelectModalProps) {
  const { brand } = useCompetitionContext();
  const { driverSelectionCheck, addDriverToTeam, removeDriverFromTeam, addDriverToPrediction, removeDriverFromPrediction } = useTeamContext();

  const handleDriverSelection = (driver: Player) => {
    if (selectionType === 'fantasyPick') {
      addDriverToTeam(driver)
    } else if(selectionStage) {
      // console.log('add driver to prediction')
      addDriverToPrediction(driver, selectedIndex, selectionStage)
    } else {
      console.log('no selection stage')
    }
  }

  const handleDriverRemove = (driver: Player) => {
    if (selectionType === 'fantasyPick') {
      removeDriverFromTeam(driver)
    } else if(selectionStage) {
      // console.log('add driver to prediction')
      removeDriverFromPrediction(driver, selectionStage)
    } else {
      console.log('no selection stage')
    }
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-md max-h-[90vh] flex flex-col">
        <div className={`bg-${brand}-header text-white p-4 rounded-t-lg flex justify-between items-center`}>
          <h2 className="text-xl font-bold">Kies een coureur</h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="overflow-y-auto flex-1">
          {drivers.map((driver, index) => {
            const selectionCheck = driverSelectionCheck(driver, selectionStage);

            return (
            <div
              key={driver.id}
              className="p-3 border-b border-gray-200 flex items-center justify-between hover:bg-gray-50"
            >
              <div className="flex items-center gap-3">
                <div className={`${getDriverBackgroundColor(driver.clubId)} p-2 rounded-lg w-12 h-12 flex items-center justify-center`}>
                  <Image
                    src={`https://dpgnl.s3.eu-west-1.amazonaws.com/jerseys/formulaone/${driver.id}.png`}
                    alt={driver.name}
                    width={40}
                    height={40}
                    className=" w-auto h-auto object-contain"
                  />
                </div>
                <div>
                  <p className='font-thin text-gray-600'>{driver.club?.name}</p>
                  <p className="font-extra">{driver.name}</p>
                  {(selectionType === 'fantasyPick') && <p className="text-gray-600">{formatPrice(toMillionPrice(driver.value))}</p>}
                </div>
              </div>
              
              {selectionCheck === 'selectable' ? (
                <button
                  onClick={() => {
                    handleDriverSelection(driver);
                    onClose();
                  }}
                  className="bg-[#75B935] text-white px-6 py-1 rounded-full hover:bg-[#669E2E] transition-colors"
                >
                  KIES
                </button>
              ) : selectionCheck === 'removable' ? (
                <button
                  onClick={() => {
                    //todo
                    handleDriverRemove(driver);
                    onClose();
                  }}
                  className="bg-red-500 text-white px-6 py-1 rounded-full"
                >
                  {/* <X size={20} />  */}
                  VERWIJDER
                </button>
              ) : 
              selectionCheck === 'clubLimit' ? 'team limiet' : 'over budget'}
            </div>
          )})}
        </div>
      </div>
    </div>
  );
}
